import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import reduxMiddleware from 'react-block-ui/lib/reduxMiddleware'
import { routerMiddleware } from 'react-router-redux'
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Store,
  StoreEnhancerStoreCreator,
} from 'redux'
// import logger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import thunk from 'redux-thunk'
import { ApplicationState, reducers } from './redux/store'

export default function configureStore(history: History, initialState?: ApplicationState) {
  // Build middleware. These are functions that can process the actions before they reach the store.
  const windowIfDefined = typeof window === 'undefined' ? null : (window as any)
  // If devTools is installed, connect to it
  // const devToolsExtension =
  //   windowIfDefined && (windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__ as () => StoreEnhancer)

  //

  const sagaMiddleware = createSagaMiddleware()

  // const oidcMiddleware = createOidcMiddleware(userManager)

  const routeMiddleware = routerMiddleware(history)
  const middlewares = [thunk, sagaMiddleware, routeMiddleware, reduxMiddleware]

  // if (process.env.NODE_ENV === 'development') {
  //   middlewares.push(logger)
  // }

  const createStoreWithMiddleware = compose<StoreEnhancerStoreCreator<any>>(
    applyMiddleware(...middlewares),
    // devToolsExtension ? devToolsExtension() : <S>(next: StoreEnhancerStoreCreator<S>) => next,
  )(createStore)

  // Combine all reducers and instantiate the app-wide store instance
  const allReducers = buildRootReducer(reducers, history)
  const store = createStoreWithMiddleware(allReducers, initialState) as Store<ApplicationState>

  return { store, sagaMiddleware }
}

// function buildRootReducer(allReducers: ReducersMapObject) {
//     return combineReducers<ApplicationState>(Object.assign({}, allReducers, { routing: routerReducer, oidc: oidcReducer }));
// }

function buildRootReducer(allReducers: any, history: History) {
  return combineReducers<ApplicationState>(
    Object.assign({}, allReducers, { router: connectRouter(history) }),
  )
}
